// @Core
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const CONTRACT_VIEWER_PDF_COMPONENT_PROPS = {
    scrollDownButton: {
      icon: {
        icon: 'icon_chevron_down',
        altText: 'Scroll to bottom',
      },
    },
    variant: VARIANTS.PDFViewerVariantType.DEFAULT,
    pdfScale: 1,
  },
  CONTRACT_VIEWER_SKELETON_COMPONENT_PROPS = {
    height: '100%',
    shapeVariant: VARIANTS.SkeletonShapeVariant.SQUARE,
    variant: VARIANTS.SkeletonVariantType.DEFAULT,
    width: '100%',
  };

export { CONTRACT_VIEWER_PDF_COMPONENT_PROPS, CONTRACT_VIEWER_SKELETON_COMPONENT_PROPS };
